import { NgModule } from '@angular/core';

import { OverAskApiService } from './services/api-service';
import { OverAskTrackingService } from './services/over-ask-tracking.service';

@NgModule({
    imports: [],
    declarations: [],
    providers: [OverAskApiService, OverAskTrackingService],
    exports: [],
})
export class OverAskModule {}
